import { useMemo } from 'react';

import translatorFor from '../i18n/translate';

import useConfiguration from './useConfiguration';

/**
 * @example const translator = useI18n();
 * @returns translator:: The translator function that provides translations for a given key  in the translation JSON provided to the Configuration component.
 */
const useI18n = () => {
  const { translations, locale } = useConfiguration();
  return useMemo(() => translatorFor(translations, locale), [translations, locale]);
};

export default useI18n;
